import { useState } from 'react'
import { useNavigate, useLocation } from 'react-router-dom'
import { useAuthStore } from '../../../features/auth'
import { getPositionsFromRoles } from '../../../entities/user'
import { PATHS } from '../../routes/paths'
import { useNavItems } from '../nav/navConfig'
import { InstallAppEntry } from '../../../features/pwa-install'

export const BurgerMenu = () => {
  const [open, setOpen] = useState(false)
  const { user, logout } = useAuthStore()
  const navigate = useNavigate()
  const location = useLocation()
  const navItems = useNavItems()

  const handleNav = (path: string) => {
    navigate(path)
    setOpen(false)
  }

  const handleLogout = () => {
    logout()
    navigate(PATHS.login)
    setOpen(false)
  }

  return (
    <>
      {/* Burger button */}
      <button
        onClick={() => setOpen(true)}
        className="p-2 rounded-md hover:bg-gray-100 focus:outline-none"
        aria-label="Menü öffnen"
      >
        <svg width="22" height="16" viewBox="0 0 22 16" fill="none" xmlns="http://www.w3.org/2000/svg">
          <rect y="0" width="22" height="2" rx="1" fill="#124093" />
          <rect y="7" width="22" height="2" rx="1" fill="#124093" />
          <rect y="14" width="22" height="2" rx="1" fill="#124093" />
        </svg>
      </button>

      {/* Overlay */}
      {open && (
        <div
          className="fixed inset-0 z-[200] bg-black/30"
          onClick={() => setOpen(false)}
        />
      )}

      {/* Drawer */}
      <div
        className={`fixed top-0 right-0 bottom-0 z-[201] w-72 bg-white shadow-xl flex flex-col transform transition-transform duration-200 ${
          open ? 'translate-x-0' : 'translate-x-full'
        }`}
      >
        {/* User info */}
        <div className="flex items-center justify-between px-5 py-4 border-b border-gray-200">
          <div>
            <p className="font-semibold text-gray-900 text-base leading-tight">{user?.name}</p>
            <p className="text-sm text-gray-500 leading-tight">{getPositionsFromRoles(user?.roles)}</p>
          </div>
          <button
            onClick={() => setOpen(false)}
            className="p-1 rounded hover:bg-gray-100"
            aria-label="Schließen"
          >
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
              <path d="M4 4L16 16M16 4L4 16" stroke="#6B7280" strokeWidth="2" strokeLinecap="round" />
            </svg>
          </button>
        </div>

        {/* Nav items */}
        <nav className="flex-1 overflow-y-auto py-2">
          {navItems.map((item) => {
            const active = location.pathname === item.path
            return (
              <button
                key={item.path}
                onClick={() => handleNav(item.path)}
                className={`w-full text-left px-5 py-3.5 text-base transition-colors flex items-center gap-3 ${
                  active
                    ? 'bg-blue-50 text-[#124093] font-semibold'
                    : 'text-gray-700 hover:bg-gray-50'
                }`}
              >
                {item.Icon && (
                  <span className="shrink-0 w-6 h-6 flex items-center justify-center">
                    <item.Icon
                      className={active ? 'text-[#124093]' : 'text-gray-400'}
                      style={{ width: 24, height: 24 }}
                      aria-hidden
                    />
                  </span>
                )}
                {item.label}
              </button>
            )
          })}
        </nav>

        {/* Install + logout. The drawer is the only place every role can reach, which is
            why the install entry lives here and not under Einstellungen (SUPERUSER only). */}
        <div className="border-t border-gray-200 px-5 py-4 space-y-3">
          <InstallAppEntry onDone={() => setOpen(false)} />
          <button
            onClick={handleLogout}
            className="w-full text-left text-base text-red-500 hover:text-red-600 py-1"
          >
            Abmelden
          </button>
        </div>
      </div>
    </>
  )
}
